import React from "react";
import { withStyles } from "@material-ui/styles";
import PropTypes from "prop-types";
import Link from "next/link";
import classNames from "classnames";

const styles = theme => ({
  root: {
    margin: "10px 0 15px"
  },

  breadcrumb: {
    ...theme.typography.faqFont,
    textDecoration: "none"
  },
  breadcrumbHover: {
    "&:hover": {
      color: theme.palette.primary.main,
      fontWeight: 600,
      cursor: "pointer"
    }
  },
  separator: {
    margin: "0 5px"
  }
});

class BreadCrumbs extends React.Component {
  render() {
    const { classes, breadcrumbList = [] } = this.props;
    return (
      <div className={classes.root}>
        {breadcrumbList.map((item, index) => {
          return (
            <span key={`breadcrumb${index}`}>
              {index < breadcrumbList.length - 1 ? (
                // <Link href={item.url}>
                <a
                  className={classNames(
                    classes.breadcrumb,
                    classes.breadcrumbHover
                  )}
                  title={item.title}
                  href={item.url}
                >
                  {item.label}
                </a>
              ) : (
                // {/* </Link> */}
                <span className={classes.breadcrumb}>{item.label}</span>
              )}
              {index < breadcrumbList.length - 1 && (
                <span className={classes.separator}>{">"}</span>
              )}
            </span>
          );
        })}
      </div>
    );
  }
}

BreadCrumbs.propTypes = {
  classes: PropTypes.object,
  breadcrumbList: PropTypes.array
};

export default withStyles(styles)(BreadCrumbs);
